import { faInfoCircle, faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";
import { useUser } from "../../contexts/UserContext";

import "./PremiumExpirationAlert.css";

const PremiumExpirationAlert = ({ setIsPricingModalOpen }) => {
  const { user, isPremiumExpiringSoon } = useUser();
  const { t } = useLanguage();

  // No mostrar nada si el usuario no está logueado o no es premium
  if (!user || !user.isPremium) {
    return null;
  }

  // Si el premium ya expiró
  if (user.premiumExpired) {
    return (
      <div className="premium-alert premium-alert--expired">
        <div className="premium-alert__icon">
          <FontAwesomeIcon icon={faWarning} color="var(--color-red)" />
        </div>
        <div className="premium-alert__content">
          <div className="premium-alert__title">
            {t("premiumSubscription.expired")}
          </div>
          <div className="premium-alert__message">
            {t("premiumSubscription.changedFree")}
          </div>
          <button
            className="premium-alert__button"
            onClick={() => setIsPricingModalOpen(true)}
          >
            {t("premiumSubscription.renewSubscription")}
          </button>
        </div>
      </div>
    );
  }

  // Si el premium está próximo a expirar
  if (isPremiumExpiringSoon(7)) {
    const { daysUntilExpiration } = user;
    const isUrgent = daysUntilExpiration <= 3;

    return (
      <div
        className={`premium-alert ${
          isUrgent ? "premium-alert--urgent" : "premium-alert--warning"
        }`}
      >
        <div className="premium-alert__icon">
          {isUrgent ? (
            <FontAwesomeIcon icon={faWarning} color="var(--color-red)" />
          ) : (
            <FontAwesomeIcon icon={faInfoCircle} color="white" />
          )}
        </div>
        <div className="premium-alert__content">
          <div className="premium-alert__title">
            {isUrgent ? "¡Atención!" : "Recordatorio"}
          </div>
          <div className="premium-alert__message">
            {t("premiumSubscription.expiredIn")} {daysUntilExpiration}{" "}
            {daysUntilExpiration === 1
              ? t("premiumSubscription.day")
              : t("premiumSubscription.days")}
          </div>
          <button
            className="premium-alert__button"
            onClick={() => setIsPricingModalOpen(true)}
          >
            {t("premiumSubscription.renewSubscriptionNow")}
          </button>
        </div>
      </div>
    );
  }

  // Si todo está bien, no mostrar nada
  return null;
};

export default PremiumExpirationAlert;
